import { ISelectOptions } from '../form/select';
import { GradeLevel } from '../grade-level';
import { StatusEnum } from '../status';
import { IStudentDTO } from '../student';
import { IGradeUnitDayDTO } from './grade-unit-day';

export interface IUnitCoverImage {
  name: string;
  mimeType: string;
  url: string;
  location?: string;
  signedUrl?: string;
  fileName?: string;
}

export class UnitCoverImage implements IUnitCoverImage {
  name: string = '';
  mimeType: string = '';
  url: string = '';
  location?: string = '';
  signedUrl?: string;
  fileName?: string = '';

  constructor(configOverride?: Partial<IUnitCoverImage>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IGradeUnitSelection {
  id: number;
  unitTitle: string;
  unitNumber: number;
  unitGradeLevel: GradeLevel;
  gradeUnitDays: IGradeUnitDaySelection[];
}

export interface IGradeUnitDaySelection {
  id: number;
  dayTitle: string;
  dayNumber: number;
  gradeLevel: GradeLevel;
}

export interface IGradeUnitDTO {
  id: number;
  unitTitle: string;
  unitNumber: number;
  unitDescription: string;
  unitGradeLevel: GradeLevel;
  unitCoverImage: IUnitCoverImage;
  unitStatus: StatusEnum;
  unitNGSSCategory: string;
  unitNGSSMetricDescription: string;
  unitNGSSMetricNumber: string;
  isDemo: boolean;
  deletedAt?: Date;
}

export class GradeUnitDTO implements IGradeUnitDTO {
  id: number = null;
  unitTitle: string = '';
  unitNumber: number = null;
  unitDescription: string = '';
  unitGradeLevel: GradeLevel = null;
  unitNGSSCategory: string = '';
  unitNGSSMetricDescription: string = '';
  unitNGSSMetricNumber: string = '';
  unitCoverImage: IUnitCoverImage;
  unitStatus: StatusEnum;
  isDemo: boolean = false;

  constructor(configOverride?: Partial<IGradeUnitDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IGradeUnitListItemDTO {
  unitId: number;
  unitNumber: number;
  unitTitle: string;
  unitDescription: string;
  unitGradeLevel: GradeLevel;
  unitCoverImageId: string;
  unitCoverImageUrl: string;
  unitStatus: StatusEnum;
  status: StatusEnum;
  unitNGSSCategory: string;
  unitNGSSMetricDescription: string;
  unitNGSSMetricNumber: string;
  assignmentStatus: string;
  enrolledStudents: IStudentDTO[];
  unitDay: IGradeUnitDayDTO[];
  deletedAt?: Date;
}

export class GradeUnitListItemDTO implements IGradeUnitListItemDTO {
  unitId: number = null;
  unitNumber: number = null;
  unitTitle: string = '';
  unitDescription: string = '';
  unitGradeLevel: GradeLevel = null;
  unitCoverImageId: string = '';
  unitCoverImageUrl: string = '';
  unitStatus: StatusEnum = StatusEnum.NULL_STATUS;
  status: StatusEnum = StatusEnum.NULL_STATUS;
  unitNGSSCategory: string = '';
  unitNGSSMetricDescription: string = '';
  unitNGSSMetricNumber: string = '';
  assignmentStatus: string = '';
  enrolledStudents: IStudentDTO[] = [];
  unitDay: IGradeUnitDayDTO[] = [];

  constructor(configOverride?: Partial<IGradeUnitListItemDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IGradeUnitRequest {
  unitId: number;
  unitTitle: string;
  unitNumber: number;
  unitDescription: string;
  unitGradeLevel: GradeLevel;
  unitCoverImage: FileList;
  unitNGSSCategory: string;
  unitNGSSMetricDescription: string;
  unitNGSSMetricNumber: string;
  unitStatus: StatusEnum;
  isDemo: boolean;
}

export class GradeUnitRequest implements IGradeUnitRequest {
  unitId: number = null;
  unitTitle: string = '';
  unitNumber: number = null;
  unitDescription: string = '';
  unitGradeLevel: GradeLevel = null;
  unitCoverImage: FileList = null;
  unitNGSSCategory: string = '';
  unitNGSSMetricDescription: string = '';
  unitNGSSMetricNumber: string = '';
  unitStatus: StatusEnum = StatusEnum.INPROGRESS;
  isDemo: boolean = false;

  constructor(configOverride?: Partial<IGradeUnitRequest>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export const unitNumberList: ISelectOptions[] = [
  {
    name: '1',
    value: '1',
  },
  {
    name: '2',
    value: '2',
  },
  {
    name: '3',
    value: '3',
  },
  {
    name: '4',
    value: '4',
  },
  {
    name: '5',
    value: '5',
  },
  {
    name: '6',
    value: '6',
  },
  {
    name: '7',
    value: '7',
  },
  {
    name: '8',
    value: '8',
  },
  {
    name: '9',
    value: '9',
  },
  {
    name: '10',
    value: '10',
  },
  {
    name: '11',
    value: '11',
  },
  {
    name: '12',
    value: '12',
  },
];

export interface MinimalGradeUnitDto {
  id: number;
  unitNumber: number;
  unitTitle: string;
  unitGradeLevel: GradeLevel;
  unitStatus: StatusEnum;
  unitDescription: string;
}
export interface GetGradeUnitListDto {
  units: MinimalGradeUnitDto[];
}
